import { useState } from "react";
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
} from "@mui/material";
import store from "../../mobx";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  ElementsConsumer,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { fetchFromApiServer } from "../../services/api";
import { Box, Stack } from "@mui/system";
import { STRIPE_PRODUCTS } from "../../constants";
import { setSubscriptionCongratulationsDialog } from "./setSubscriptionCongratsDialog";
import { useNavigate } from "react-router";

const { dialogStore, snackbarStore } = store;

const stripePromise = loadStripe(
  "pk_test_51Ni7ncBik4ttaSLwkMzQQfUjcVaG7rCZ5n6RvYN1zNmihnK5IzR8Z4sImspEkPrFsZGTNw2z1Td3CI0OqA6CSoqS00GCg67VNc"
);

// const createPaymentIntentUrl =
//   process.env.NODE_ENV === "production"
//     ? "https://us-central1-last-year-18294.cloudfunctions.net/createIntent"
//     : "http://127.0.0.1:5001/last-year-18294/us-central1/createIntent";

// const confirmPaymentIntentUrl =
//   process.env.NODE_ENV === "production"
//     ? "https://us-central1-last-year-18294.cloudfunctions.net/confirmIntent"
//     : "http://127.0.0.1:5001/last-year-18294/us-central1/confirmIntent";

const createPaymentIntentUrl =
  "https://us-central1-last-year-18294.cloudfunctions.net/createIntent";

const confirmPaymentIntentUrl =
  "https://us-central1-last-year-18294.cloudfunctions.net/confirmIntent";
const AMOUNT = 40_00;

const CheckoutForm = ({ stripe, elements }) => {
  const [submitted, setSubmitted] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setSubmitted(true);

      const { error: submitError } = await elements.submit();
      if (submitError) {
        setSubmitted(false);
        return;
      }

      const productId = STRIPE_PRODUCTS.products.MixQuickEarlyAccess.productId;

      // Step 1: Call backend to create a PaymentIntent
      const res = await fetchFromApiServer(createPaymentIntentUrl, {
        method: "POST",
        body: JSON.stringify({
          productId,
        }),
      });

      if (!res.ok) {
        throw new Error("Failed to create payment intent");
      }

      const { client_secret } = await res.json();

      // Step 2: Confirm the payment
      const { error: confirmError } = await stripe.confirmPayment({
        elements,
        clientSecret: client_secret,
        confirmParams: {
          return_url: window.location.href, // optional
        },
        redirect: "if_required",
      });

      if (confirmError) {
        console.error(confirmError);
        snackbarStore.set.message("Payment failed. Please try again.");
        setSubmitted(false);
        return;
      }

      // now we verify that stripe has updated itself on our backend to keep the product saved to the user's profile
      await fetchFromApiServer(confirmPaymentIntentUrl, {
        method: "POST",
        body: JSON.stringify({
          client_secret,
          productId,
        }),
      }).then((res) => {
        if (res.ok) {
          return;
        } else {
          throw new Error(
            `Could not validate stripe received payment, status: ${res.status}`
          );
        }
      });

      setSubscriptionCongratulationsDialog();
      navigate("/products");
    } catch (error) {
      console.error(error);
      setSubmitted(false);
      snackbarStore.set.message("Something went wrong, please try again later");
      dialogStore.set.open(false);
    }
  };

  return (
    <>
      <DialogContent
        sx={{
          minHeight: 300,
          width: "100%",
          pb: 0,
          overflowY: "hidden",
        }}
      >
        <PaymentElement options={{}} />
        <Fade in={submitted}>
          <Stack
            alignItems="center"
            sx={{ width: "100%", height: "100%", pt: 4 }}
          >
            <Box>
              <CircularProgress />
            </Box>
          </Stack>
        </Fade>
      </DialogContent>

      <DialogActions sx={{ pt: 1, pb: 2 }}>
        <Button
          variant="text"
          color="error"
          onClick={() => store.dialogStore.set.open(false)}
          sx={{
            ml: 2,
            fontSize: 16,
            borderColor: "grey.300",
            color: "grey.300",
          }}
        >
          Cancel
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleSubmit}
          sx={{ mr: 2, fontSize: 16 }}
        >
          Purchase
        </Button>
      </DialogActions>
    </>
  );
};

const InjectedCheckoutForm = () => (
  <ElementsConsumer>
    {({ stripe, elements }) => (
      <CheckoutForm stripe={stripe} elements={elements} />
    )}
  </ElementsConsumer>
);

export const setPurchaseDialog = async () => {
  if (store.userStore.session.isAnonymous) {
    await store.userStore.authWithGoogle();
  }

  dialogStore.set.dialog({
    fullScreen: store.mediaBreakpointStore.isPhone,
    Title: () => <DialogTitle>Purchase Mix Quick Early Access</DialogTitle>,
    Content: () => (
      <Elements
        stripe={stripePromise}
        options={{
          mode: "payment",
          amount: AMOUNT,
          paymentMethodCreation: "manual",
          currency: "usd",
          appearance: {
            // theme: "flat",
            labels: "floating",
            variables: {
              //   colorText: "#fff",
            },
          },
        }}
      >
        <InjectedCheckoutForm />
      </Elements>
    ),
  });
  dialogStore.set.open(true);
};
